import {useNavigation, useRoute} from '@react-navigation/native';
import React, {useState} from 'react';
import {
   StyleSheet,
   TouchableOpacity,
   View,
   Text,
   Platform,
   Image,
} from 'react-native';
import {CopyRight} from '../../utils/CopyRight';
import {
   appBackground,
   primaryColor500,
   primaryColor700,
   QrBarcodeSignIn,
   tabSelector,
   FONT_FAMILY_REGULAR,
   scanBarcode,
   scanQRcode,
   appBackgroundWhiteBG,
   BUTTON_HOVER_COLOR,
   isHoverEnabled,
   isWeb,
} from '../../utils/utils';
import BarCodeGenerator from './barcode';
import GenerateQRCode from './qrcode';
import {ApplicationHeader} from '../../utils/application_header';
import logger from '../../utils/logger';
import {selectScreenOrientation} from '../../redux/slices/ScreenOrientationSlice';
import {useSelector} from 'react-redux';
import {CopyRightForTab} from '../../utils/CopyRightForTab';

const QRAndBarcodeScreen = props => {
   const isLandscapeMode = useSelector(selectScreenOrientation);

   const [isQRVisible, setIsQrVisible] = useState(false);
   const navigation = useNavigation();
   const prams = useRoute();
   logger(`------- ${prams}}`);
   const nID = prams.params.norcatID;
   const qrID = prams.params.qrID;
   return (
      <View
         style={[
            styles.container,
            isWeb && isLandscapeMode && {minHeight: 500},
         ]}>
         <ApplicationHeader
            OnBackPress={() => {
               navigation.goBack();
            }}
            title={QrBarcodeSignIn}
         />

         <ActionsButtons
            selectedButton={isQRVisible}
            qrAction={handleQrButton}
            barAction={handleBarButton}
         />
         {isQRVisible ? (
            <GenerateQRCode valueStr={qrID} />
         ) : (
            <BarCodeGenerator valueStr={nID} />
         )}
         {isLandscapeMode ? (
            <View>
               <CopyRightForTab
                  isPortrait={!isLandscapeMode}
                  isCopyrightShown={true}
               />
            </View>
         ) : (
            <View style={{marginBottom: !isLandscapeMode ? 5 : 0}}>
               <CopyRight
                  screenOrientation={isLandscapeMode}
                  isCopyrightShown={true}
               />
            </View>
         )}
      </View>
   );

   function handleQrButton() {
      setIsQrVisible(true);
   }
   function handleBarButton() {
      setIsQrVisible(false);
   }
   function handleBack() {
      logger('Back Press');
      navigation.goBack();
   }
};

const ActionsButtons = props => {
   const [qrHover, setQrHover] = React.useState(false);
   const [brHover, setBrHover] = React.useState(false);
   return (
      <View style={styles.QrBarContainer}>
         <View
            style={{
               flexDirection: 'row',
               flex: 1,
               justifyContent: 'flex-start',
               alignItems: 'center',
            }}>
            <TouchableOpacity
               onPress={() => {
                  props.qrAction();
               }}
               onMouseEnter={() => {
                  setQrHover(true);
               }}
               onMouseLeave={() => {
                  setQrHover(false);
               }}
               style={[
                  styles.buttonContainer,
                  {
                     backgroundColor:
                        qrHover && isHoverEnabled
                           ? BUTTON_HOVER_COLOR
                           : props.selectedButton
                           ? '#003389'
                           : '#003DA6',
                     borderColor: props.selectedButton
                        ? tabSelector
                        : primaryColor500,
                  },
               ]}>
               <Text
                  style={[
                     styles.buttonText,
                     {opacity: !props.selectedButton ? 0.6 : 1},
                  ]}>
                  {scanQRcode}
               </Text>
            </TouchableOpacity>
            <TouchableOpacity
               onPress={() => {
                  props.barAction();
               }}
               onMouseEnter={() => {
                  setBrHover(true);
               }}
               onMouseLeave={() => {
                  setBrHover(false);
               }}
               style={[
                  styles.buttonContainer,
                  {
                     backgroundColor:
                        brHover && isHoverEnabled
                           ? BUTTON_HOVER_COLOR
                           : !props.selectedButton
                           ? '#003389'
                           : '#003DA6',
                     borderColor: props.selectedButton
                        ? primaryColor500
                        : tabSelector,
                  },
               ]}>
               <Text
                  style={[
                     styles.buttonText,
                     {opacity: props.selectedButton ? 0.6 : 1},
                  ]}>
                  {scanBarcode}
               </Text>
            </TouchableOpacity>
         </View>
      </View>
   );
};

const styles = StyleSheet.create({
   container: {
      flex: 1,
      justifyContent: 'space-between',
      alignContent: 'center',
      backgroundColor: appBackgroundWhiteBG,
      ...Platform.select({
         web: {
            flex: null,
            width: '100%',
            height: '100vh',
         },
      }),
   },
   QrBarContainer: {
      maxHeight: 50,
      justifyContent: 'space-between',
      flexDirection: 'row',
   },
   buttonText: {
      color: 'white',
      fontSize: 10,
      fontWeight: '500',
      textAlign: 'center',
      textAlignVertical: 'center',
      fontFamily: FONT_FAMILY_REGULAR,
   },
   buttonContainer: {
      minHeight: 46,
      flex: 1,
      justifyContent: 'center',
      borderBottomWidth: 0,
   },
});

export default QRAndBarcodeScreen;
